var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.hint)?_c('n8n-text',{attrs:{"size":"xsmall","color":"text-base"}},[_c('div',{ref:"hint",domProps:{"innerHTML":_vm._s(_vm.hint)}})]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }